import axios from "axios";

export const resolveApiBaseUrl = () => {
  const configuredBackendUrl = process.env.REACT_APP_BACKEND_URL?.trim();

  if (process.env.NODE_ENV === "production") {
    return configuredBackendUrl ? `${configuredBackendUrl}/api` : "/api";
  }

  return configuredBackendUrl ? `${configuredBackendUrl}/api` : "http://localhost:8000/api";
};

export const API = resolveApiBaseUrl();

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});
